import { DirectoryAutocompleteField } from 'features';
import { lodash } from 'helpers';
import { useIsFormEditable } from 'hooks';
import { useTranslation } from 'libs/i18n';
import { OrderSection } from 'modules/order/common/components';
import { Field, useField } from 'modules/order/common/forms/orderForm';

import { NewLabel } from '../../NewLabel';

import { useFinancialInstrumentSection } from './useFinancialInstrumentSection';

export const FinancialInstrumentSection = () => {
  const { t } = useTranslation();

  const { onChangeIsin, financialInstruments } =
    useFinancialInstrumentSection();

  const { field: isinField } = useField('financialInstrument.isin');

  const isEditable = useIsFormEditable();

  const isinLabel =
    isinField.value?.record?.isNew && !isEditable ? (
      <NewLabel
        label={t('order.sections.financialInstrumentSection.fields.isin.label')}
      />
    ) : (
      t('order.sections.financialInstrumentSection.fields.isin.label')
    );

  return (
    <OrderSection
      fields={lodash.compact([
        financialInstruments ? (
          <DirectoryAutocompleteField<{ value: string; label: string }, false>
            fullWidth
            showRequiredMark
            directorySchemaName={financialInstruments.isin.directorySchemaName}
            fieldName={financialInstruments.isin.fieldName}
            label={isinLabel}
            name="financialInstrument.isin"
            placeholder={t(
              'order.sections.financialInstrumentSection.fields.isin.placeholder'
            )}
            onChange={onChangeIsin}
          />
        ) : (
          <Field.Text
            fullWidth
            readOnly
            disabled={isEditable}
            label={isinLabel}
            name="financialInstrument.isin.label"
          />
        ),

        <Field.Text
          fullWidth
          disabled={isEditable}
          label={t(
            'order.sections.financialInstrumentSection.fields.securityType.label'
          )}
          name="financialInstrument.securityType"
        />,
        <Field.Text
          fullWidth
          disabled={isEditable}
          label={t(
            'order.sections.financialInstrumentSection.fields.issuer.label'
          )}
          name="financialInstrument.issuer"
        />,
      ])}
      title={t('order.sections.financialInstrumentSection.title')}
    />
  );
};
